import  React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { browserHistory } from 'react-router'
import _ from 'lodash';

import {Table, Thead, Tbody, Tr, Td, Th} from 'reactable';

import {Col, Row, Container} from 'src/components/Common/reactstrap/lib';


class Results extends Component {

 fuzzy(url){
   window.location.assign(url);
 }
  render() {
    let results = this.props || {};
    console.log(this);
    let tableRows = _.map(results.data, (value, index) => {
        return (

          <Tr key={index} style={{cursor:'pointer'}}
              onClick={() => this.fuzzy(`search?article=${results.article}&detailid=${value.detail.detailId}`)}>
            <Td column="Производитель">
              <Row>
                <Col sm="6">
                  {value.detail.brandName} {value.detail.article}
                </Col>
                <Col sm="5">
                  {value.detail.name}
                </Col>
              </Row>

            </Td>
            <Td column="Описание">
              {value.description}
            </Td>
            <Td column="Искомый">
              <span>от {value.lowOriginalPrice.toLocaleString()} &#8381;</span>
            </Td>
            <Td column="Аналог">
              <span>от {value.lowAnalogPrice.toLocaleString()} &#8381;</span>
            </Td>
            <Td column="Срок">
              <span>от {value.lowDeliveryTerms.toLocaleString()} дн.</span>
            </Td>
          </Tr>
        );

    });
    return (
    <div>
      {(results.data.length > 0 && !results.data[0].detail.isExactEquality)  && <h2>По вашему запросу {this.props.article} ничего не найдено, возможно вы имели ввиду
      </h2>}
      {(results.data.length > 0 && results.data[0].detail.isExactEquality) && <h2>По вашему запросу {this.props.article} найдено несколько разных позиций
      </h2>}
      <Table className="table table-hover fuzzy">

        {tableRows}
      </Table>
  </div>
    );
  }
}

export default Results;



/** WEBPACK FOOTER **
 ** ./src/components/Search/elements/Fuzzy.jsx
 **/